"use client";

import { useEffect, useState } from "react";

export const useBibleHTML = (html: string): [string, string, string] => {
  // server rendering of raw HTML differs from client rendering, so we need to make this state
  const [html1, setHtml1] = useState<string>(undefined);
  const [html2, setHtml2] = useState<string>(undefined);
  const [html3, setHtml3] = useState<string>(undefined);

  // HTML is always - always - in 3 pieces
  //  1. the header before the topContentLink
  //  2. the body
  //  3. the copyright after the bottomContentLink
  // We're using components for deeplinks, so we need to attach those ourselves

  useEffect(() => {
    if (!html) {
      setHtml1(undefined);
      setHtml2(undefined);
      setHtml3(undefined);
    } else {
      const htmlPieces1 = html?.split(
        /<div (?:class|id)="topContentLink"><\/div>/,
      );
      const htmlPieces2 = htmlPieces1[1]?.split(
        /<div (?:class|id)="bottomContentLink"><\/div>/,
      );
      setHtml1(htmlPieces1?.[0]);
      setHtml2(htmlPieces2?.[0]);
      setHtml3(htmlPieces2?.[1]);
    }
  }, [html]);

  return [html1, html2, html3];
};
